/**
 * roleCategories.ts — 岗位分类统一数据源
 * 同时被 marketplaceData.ts 和 home/page.tsx 消费，
 * 彻底消除两处重复定义。
 */

export const roleCategories: Record<string, string[]> = {
  '销售市场类': [
    '销售猎手', '外呼专员', '销售顾问', '客户经理', '商务拓展', '微信拓客专员', '私域培育专员',
    '邀约成交专员', '签单成交专员', '客户拓展策略师', '销售教练', '赢单策略师', '需求挖掘顾问',
    '售前工程师', '冷启动获客专员', '销售漏斗分析师', '投标策略师',
    '付费媒体审计师', '广告创意策略师', '社交广告策略师', 'PPC竞价策略师', '程序化广告采买专家',
    '搜索词分析师', '追踪与归因专家', '政务数字化售前顾问', '供应链采购策略师',
  ],
  '客服售后类': [
    '智能客服', '技术支持', '售后专员', '电商客服', '网站客服', '通用客服',
  ],
  '数据运营类': [
    '质检专员', '新媒体数据分析师', '工作流优化师', '实验追踪员',
    '报告分发师', '销售数据提取师', '高管摘要师', '财务追踪员',
    '数据工程师', '数据库优化师', '数据整合师', '电商运营专员', '直播运营员',
  ],
  '技术开发类': [
    '基础设施运维师', '前端工程师', '后端架构师', 'AI工程师', 'DevOps自动化工程师',
    '快速原型开发师', '高级开发工程师', '移动端开发', 'QA工程师', '性能测试专家',
    '安全工程师', '测试工程师-Bug挖掘', '威胁检测工程师', '微信小程序开发',
    '技术文档工程师', '自主优化架构师', '故障响应指挥官', 'SRE站点可靠性工程师',
    '飞书集成开发工程师', '代码审查员', 'Git版本管理工程师', '软件架构师',
    '工具评估师', 'LSP索引工程师',
    '智能体编排工程师', '提示词工程师', 'MCP开发工程师', '文档自动化工程师', '模型QA专家',
  ],
  '创意设计类': [
    'AI图像提示词工程师', '插画师', '品牌设计师',
    'Logo设计师', '字体设计师', '视觉形象顾问', '平面设计师', '画册排版设计师',
    '包装设计师', '书籍装帧设计师', '信息图表设计师',
    'UI设计师', 'UX设计师', '交互设计师', '移动端设计师', '网页设计师', '图标设计师',
    '动效设计师（界面）', '用户体验研究员', '无障碍审核员', '设计规范制定者', '产品体验设计师',
    '电商视觉设计师', '运营设计师', '广告创意设计师',
    '三维建模师', '渲染师', '产品渲染师', '空间设计师', '展览设计师', '陈列设计师',
    '动态图形设计师', '视频包装师', '影视后期合成师', '音效设计师', 'AIGC设计师',
    '游戏UI设计师', '游戏原画师', '角色设计师', '创意总监', '品牌资产管理员',
    '视觉叙事师', '包容性视觉专家',
  ],
  '法务合规类': [
    '法务专员', '合同管理员', '知识产权专员', '劳动法务专家', '合规官', '数据合规官', '风险经理',
    '食品标签合规审核员',
  ],
  '人力资源类': [
    '招聘专员', '员工关系专员', '薪酬福利专员', '培训专员', '绩效专员',
    '招聘运营专家', '企业培训课程设计师',
  ],
  '产品设计类': [
    '产品设计师', 'CMF设计师', '手板模型师', '逆向工程师', '产品策略师', '用户研究员',
    '家具设计师', '玩具设计师', '文创产品设计师', '家居设计师', '玻璃制品设计师',
    'UX架构师',
  ],
  '媒体运营类': [
    '新媒体运营专员', '微信公众号运营', '小红书运营', '抖音运营', '微博运营',
    'B站运营', '视频号运营', '知乎运营', '内容策划', '短视频编导', '直播运营专员',
    '直播主播（数字人）', '社群运营专员', '用户运营', '短视频剪辑师', '快手策略师',
    '私域流量运营师', '直播电商主播教练', '短视频剪辑指导师', '播客内容策略师',
    '社交媒体策略师', '轮播图运营专员', '视频创作官', '直播主播',
  ],
  '项目管理运营类': [
    '项目协调员', '高级项目经理', '项目协调专员', '工作室制片人', '工作室运营',
    'Jira管理员', '测试验证专员', '质量保障工程师', 'API测试员', '性能基准师',
    '测试结果分析师', '趋势研究员', '反馈分析师', '用户行为策略师', 'Sprint排序师',
    '电商优化师', '电商运营专员', '网站运营专员', '社群管理员', '百度SEO专家',
    '跨境电商运营专家', 'SEO专家（通用）',
  ],
  '生产管理岗': [
    '生产计划专员', '生产调度员', '品质管理员', 'QC检验员', '生产线长',
    '设备维护工程师', '供应商管理专员', '库存管理专员', '精益生产顾问',
    'ERP运营专员', '物料管理员', '产能优化师', '工厂数字化专员',
    '工序优化工程师', '安全生产专员', 'BOM管理员', '排产优化师', '制造成本核算员',
  ],
  '其他专业岗': [
    '身份信任架构师', '应付账款自动化专员', '身份图谱操作员', '文化智能策略师',
    '开发者布道师', '知识库管理员',
    'visionOS空间工程师', 'macOS Metal空间工程师', 'XR界面架构师', 'XR沉浸式开发者',
    'XR座舱交互专家', '终端集成专家',
    '包装结构师', '报价员（包装行业）', '开单员（包装行业）', '印前制作员',
  ],
};

// ─── 分类图标映射 ──────────────────────────────────────────────────────────
export const categoryIconMap: Record<string, string> = {
  '销售市场类':    'ri-line-chart-line',
  '客服售后类':    'ri-customer-service-2-line',
  '数据运营类':    'ri-bar-chart-box-line',
  '技术开发类':    'ri-code-s-slash-line',
  '创意设计类':    'ri-palette-line',
  '法务合规类':    'ri-scales-line',
  '人力资源类':    'ri-team-line',
  '产品设计类':    'ri-tools-line',
  '媒体运营类':    'ri-broadcast-line',
  '项目管理运营类': 'ri-clipboard-line',
  '生产管理岗':    'ri-settings-3-line',
  '其他专业岗':    'ri-star-line',
};

// ─── 分类颜色映射 ──────────────────────────────────────────────────────────
export const categoryColorMap: Record<string, string> = {
  '销售市场类':    '#10b981',
  '客服售后类':    '#0ea5e9',
  '数据运营类':    '#f59e0b',
  '技术开发类':    '#8b5cf6',
  '创意设计类':    '#ec4899',
  '法务合规类':    '#64748b',
  '人力资源类':    '#14b8a6',
  '产品设计类':    '#f97316',
  '媒体运营类':    '#a855f7',
  '项目管理运营类': '#0284c7',
  '生产管理岗':    '#16a34a',
  '其他专业岗':    '#94a3b8',
};

// ─── 反向查找表（角色名 → 分类名） ──────────────────────────────────────
const _roleToCategory: Record<string, string> = {};
Object.entries(roleCategories).forEach(([cat, roles]) => {
  roles.forEach(role => { _roleToCategory[role] = cat; });
});

/** 根据角色名返回所属分类，找不到则归入「其他专业岗」 */
export function getRoleCategory(role: string): string {
  return _roleToCategory[role] || '其他专业岗';
}
